import {
  GET_DATA_FROM_SERVER_API_CALL,
  GET_DATA_FROM_SERVER_API_CALL_SUCCESS,
  GET_DATA_FROM_SERVER_API_CALL_FAIL,
  LOG_OUT,
  CLEAR_DATA_BY_KEY,
  IS_ERROR_CLEAR,


} from './ActionType';

const initialState = {
  loading: false,
  isError: false,
  globleMessage: '',
  apiResponses: {},
  globalLoading: false,
  currentLocation: {},
  onlineDrivers: [],

};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_FROM_SERVER_API_CALL:
      console.log('API Success:', action.payload);
      return {
        ...state,
        [action.payload?.key]: {
          loading: true,
          inError: false,
          response: {},
          error: {},
        },
        loading: true,
        isError: false,
      };

    case GET_DATA_FROM_SERVER_API_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        isError: false,
        globalLoading: false,
        globleMessage: '',
        [action.payload.existing_payload?.key]: {
          loading: false,
          inError: false,
          response: action.payload.server_res,
          error: {},
        },
      };

    case GET_DATA_FROM_SERVER_API_CALL_FAIL:
      return {
        ...state,
        loading: false,
        isError: true,
        globalLoading: false,
        globleMessage: action.payload.server_res,
        [action?.payload?.existing_payload?.key]: {
          loading: false,
          inError: true,
          response: {},
          error: action.payload.server_res,
        },
      };
   
    case CLEAR_DATA_BY_KEY:
      return {
        ...state,
        [action.payload?.key]: {},
        loading: false,
        isError: false,
        globalLoading: false,
      };

    case LOG_OUT:
      // clearAllDataAsyncStorage()
      return {
        ...initialState,
        globleMessage: '',
        loading: false,
        isError: false,
        isGlobaloding: false,
      };
    case IS_ERROR_CLEAR:
      return {
        ...state,
        globleMessage: '',
        loading: false,
        isError: false,
        isGlobaloding: false,
      };



    default:
      return state;
  }
};

export default reducer;
